import { put } from '@/utils/fetch'

export const updateTeam = async (
  newChildren: string[],
  removeMemberId?: string,
) => {
  const result = await put<{ success: boolean }>('/team', { newChildren, removeMemberId })
  return result
}
